import { fbt } from 'fbtee'
import { Settings } from 'lucide-react'
import { OptionChip } from '../../../components/OptionChip'

export function SettingsButton({ onClick }: { onClick: () => void }) {
  return (
    <OptionChip
      icon={<Settings className="size-5" />}
      label={fbt('Customize', 'Schedule chip label to customize stage order and visibility')}
      title={fbt('Schedule settings. Tap to customize stage order and visibility.', 'Tooltip on the schedule settings chip')}
      onClick={onClick}
    />
  )
}
